import React from "react";
import ReactDOM from "react-dom/client";
import "antd/dist/reset.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import { theme } from "./utils/theme";
import { MessageProvider } from "./store/MessageContext";
import { AuthProvider } from "./store/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ConfigProvider theme={theme}>
      <MessageProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </MessageProvider>
    </ConfigProvider>
  </BrowserRouter>
  // </React.StrictMode>
);
